import { xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { Ratings as RatingsV2 } from '@atlassian/mpac-primitives';
import { AppListingTab } from '@atlassian/mpac-types';
import { UrlUtils, useSource, WindowUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { useHistory } from '../../../../primitives/Router';
import { ANALYTICS_SUBJECT_ID_RATINGS } from '../../AppHeader.constants';
import { jsx as _jsx } from "react/jsx-runtime";
const pressableStyles = xcss({
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed'
  },
  borderRadius: 'radius.small',
  paddingLeft: 'space.0',
  paddingRight: 'space.0'
});
const HeaderRatings = props => {
  const source = useSource();
  const isEmcee = source === 'PRODUCT';
  const history = useHistory();
  const {
    enableAppReviewsFromStoreBff
  } = useStatsig();
  const isReviewsFromBffEnabled = enableAppReviewsFromStoreBff();
  const {
    appRatingLink,
    openMarketplaceLinksInNewTab,
    appKey,
    ratings,
    onTabChange
  } = props;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onRatingsClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_RATINGS
    });
    if (isEmcee && isReviewsFromBffEnabled) {
      onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(AppListingTab.Reviews);
    } else if (openMarketplaceLinksInNewTab) {
      const appReviewsUrl = appRatingLink.expand({
        appKey
      });
      WindowUtils.openPage(appReviewsUrl, '_blank');
    } else {
      history === null || history === void 0 ? void 0 : history.push(UrlUtils.updateQueryParam(window.location.href, 'tab', 'reviews'));
    }
  };
  return /*#__PURE__*/_jsx(Pressable, {
    xcss: pressableStyles,
    backgroundColor: "color.background.neutral.subtle",
    onClick: onRatingsClick,
    children: /*#__PURE__*/_jsx(RatingsV2, {
      ratings: ratings,
      testId: "app-header-ratings",
      showNoRatingsMessage: true,
      boldAverageStars: true
    })
  });
};
export default HeaderRatings;